'use client';

import { useSuspenseQuery } from '@apollo/client/react';
import { FC, PropsWithChildren, useMemo } from 'react';

import { User } from '@/.gql/graphql';
import { GET_SUBSCRIBERS } from '@/.graphql';

import { createCustomContext } from './context';

interface ISubscribersProps {
  subscribers: Array<User>;
}

const [SubscribersContext, useSubscribersContext] =
  createCustomContext<ISubscribersProps>({
    name: 'SubscriptionsContext',
    strict: false,
  });

export { useSubscribersContext };

interface Props extends PropsWithChildren {
  userId: string;
}

export const SubscribersProvider: FC<Props> = ({ children, userId }) => {
  const { data } = useSuspenseQuery(GET_SUBSCRIBERS, {
    variables: { userId },
  });

  const subscribers = useMemo(() => data?.getSubscribers ?? [], [data]);

  const contextValue = useMemo(() => ({ subscribers }), [subscribers]);

  return (
    <SubscribersContext value={contextValue}>{children}</SubscribersContext>
  );
};
